// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import AddressSharedStyles from "@rpsc/App/SharedStyles/xAddressStyles";
import { locationSearchFormStyles } from "@rpsc/Overrides/Components/LocationSearchForm";
import IconSearch from "@rpsc/XDL/Icons/IconSearch";
import { fontConfig } from "@rpsc/XDL/PreStyle/typography";
import { color, styledScrollbar, xScreen } from "@rpsc/XDL/Utilities";
import { css } from "styled-components";

locationSearchFormStyles.searchContainer = {
    css: css`
        display: grid;
    `,
};

locationSearchFormStyles.searchLocationsText = {
    iconProps: {
        src: IconSearch,
    },
};

locationSearchFormStyles.searchResultRow = {
    css: css`
        height: 450px;
        ${styledScrollbar()}
    `,
};

locationSearchFormStyles.searchResultLocationGridItem = {
    width: 11,
    css: css`
        align-items: center;
    `,
};

locationSearchFormStyles.locationAddressInfoCondensed = {
    addressText: AddressSharedStyles.address.address1Text,
    countryText: AddressSharedStyles.address.countryText,
    cityStatePostalCodeText: AddressSharedStyles.address.cityStatePostalCodeText,
};

locationSearchFormStyles.locationDistanceDisplayText = {
    ...AddressSharedStyles.address.address1Text,
};

locationSearchFormStyles.locationNameLink = {
    typographyProps: {
        size: 16,
        weight: fontConfig.weight.bold,
    },
};

locationSearchFormStyles.searchResultContentGridItem = {
    width: [11, 3, 3, 3, 2],
    css: css`
        align-items: center;
    `,
};

locationSearchFormStyles.searchResultGoogleMapsDirectionLinkGridItem = {
    width: [11, 3, 3, 3, 2],
    css: css`
        align-items: center;
        &&& {
            ${xScreen("lte", "xs")} {
                margin-left: 8%;
            }
        }
    `,
};

locationSearchFormStyles.searchResultDistanceGridItem = {
    width: [11, 5, 5, 5, 4],
    css: css`
        &&& {
            ${xScreen("lte", "xs")} {
                margin-left: 8%;
            }
        }
    `,
};

locationSearchFormStyles.searchResultDivider = {
    css: css`
        margin: 16px 0;
        border: 1px solid ${color("common.border")};
        width: 100%;
    `,
};

locationSearchFormStyles.paginationRow = {
    css: css`
        display: flex;
        justify-content: flex-end;
    `,
};
locationSearchFormStyles.searchResultDisplayNumberGridItem = {
    width: 1,
    css: css`
        justify-content: center;
        ${xScreen("lte", "xs")} {
            padding: 4px 0;
            white-space: nowrap;
        }
    `,
};

locationSearchFormStyles.searchResultGridContainer = {
    gap: 10,
    offsetCss: css`
        &&& {
            width: 100%;
        }
    `,
};

locationSearchFormStyles.notify = {
    css: css`
        max-width: unset;
    `,
};

locationSearchFormStyles.distanceUnitOfMeasureRadioGroup = {
    horizontal: true,
    css: css`
        display: flex;
        width: 100%;
        flex-direction: row;
        gap: 20px;
        justify-content: end;
        & > div {
            display: inline-flex;
        }
    `,
};
